import { Navigate, Outlet, useLocation } from 'react-router-dom';

import './tabel-layout.scss';

import { useIsHr, useIsTabel } from '~modules/auth/model';
import { routerKeys } from '~shared/router';

export function TabelLayout() {
	const isTabel = useIsTabel();
	const isHr = useIsHr();
	const location = useLocation();

	if (!isTabel && !isHr) {
		return <Navigate to={routerKeys.denied()} replace />;
	}

	const isProtectedRoute = ![
		routerKeys.tabel.root(),
		routerKeys.tabel.addUser(),
		routerKeys.tabel.attendance(),
	].includes(location.pathname.replace(/\/\d+$/, ''));

	if (isTabel && !isHr && isProtectedRoute) {
		return <Navigate to={routerKeys.tabel.root()} replace />;
	}

	return (
		<div className="tabel-layout">
			<div className="tabel-layout__body">
				<Outlet />
			</div>
		</div>
	);
}
